import { Paper, Button, Typography, LoginIcon } from 'src/components';
import { useIsMobile } from 'src/hooks';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { DesktopProfileModal } from 'src/pages/profile';

export default function LoginPrompt({ message, height, sx }) {
  const [displayLogin, setDisplayLogin] = useState(false);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleSignInClick = () => {
    if (isMobile) {
      navigate('/profile');
    } else {
      setDisplayLogin(true);
    }
  };

  return (
    <>
      <Paper
        variant="outlined" 
        sx={{
          mt: 2,
          border: '2px dashed',
          borderColor: 'divider',
          borderRadius: 1,
          height: height,
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        {...sx}
      >
        <Typography variant="body2" fontWeight={600} sx={{ color: 'text.secondary' }}>
          {message}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          startIcon={<LoginIcon />}
          sx={{ borderRadius: 2, mt: 2 }}
          onClick={handleSignInClick}
        >
          Sign In
        </Button>
      </Paper>

      <DesktopProfileModal displayLogin={displayLogin} setDisplayLogin={setDisplayLogin} />
    </>
  );
}
